import React, { useEffect, useState } from 'react'
//@ts-ignore
import s from './ErrorModal.module.scss'

export type Modal = {
    title: string;
    message: string;
    isInfo?: boolean;
    onClose: any
}

export const ErrorModal = ({ ...props }: Modal): any => {
    const { title, message, isInfo, onClose } = props;


    return (
        <>
            <div className={s.errorModal}>
                <div className={s.header}>
                    <div className={s.close} onClick={() => onClose()}>
                        <img src="/assets/svg/CloseIcon.svg" alt="" />
                    </div>
                    <div className={s.iconModal}>
                        {!!isInfo ? <img src="/assets/svg/InfoIcon.svg" alt="" /> : <img src="/assets/svg/ErrorIcon.svg" alt="" />}
                    </div>
                    <div className={s.title}>{title}</div>
                </div>
                <div className={s.main}>
                    <div className={s.text}>{message}</div>
                </div>
                <button className={`${s.btn} ${s.btn_gray} `} onClick={() => onClose()} >ok</button>
            </div>
        </>
    )
}
